import { render, staticRenderFns } from "./ApprovalTable.vue?vue&type=template&id=0e6f7a76&scoped=true"
import script from "./ApprovalTable.vue?vue&type=script&lang=js"
export * from "./ApprovalTable.vue?vue&type=script&lang=js"
import style0 from "./ApprovalTable.vue?vue&type=style&index=0&id=0e6f7a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f7a76",
  null
  
)

export default component.exports